import { BaseStorage } from "@/storage/BaseStorage";
import Bugsnag from "@bugsnag/js";
import { ColibriTableConfiguration } from "@/core/ColibriTableConfiguration";
import { ColibriAPI } from "@/api/ColibriAPI";
import { ColibriItem } from "./ColibriItem";
import { TableOverview, TableStatus } from "../Table";
import { TableItem } from "../TableItem";
import { ClosingTableException } from "../expections/ClosingTableException";
import { LockedTableException } from "../expections/LockedTableException";
import { PosPendencyException } from "../expections/PosPendencyException";

export class ColibriTable {
  constructor() {
    this.colibriConfiguration = ColibriTableConfiguration.fromStorage();

    Bugsnag.leaveBreadcrumb(
      "Configurações da Ecletica",
      this.colibriConfiguration.export()
    );

    const tableNumber = this.colibriConfiguration.externalId;
    this.storage = new BaseStorage({ key: `of-colibri-table-${tableNumber}` });

    this.client = new ColibriAPI({
      host: this.colibriConfiguration.host,
      port: this.colibriConfiguration.port,
      apiKey: this.colibriConfiguration.apiKey || null,
      user: this.colibriConfiguration.user,
      password: this.colibriConfiguration.password,
    });
  }

  async addItems(order) {
    const status = await this.getStatus();
    if (status === TableStatus.PRECLOSED || status === TableStatus.CLOSED) {
      throw new ClosingTableException();
    }

    const items = order.cart.catalog.items || [];

    const builtItems = ColibriItem.fromOlga(items, this.colibriConfiguration);

    const response = await this.client.addItemToOrder({
      table: this.colibriConfiguration.externalId,
      mode: 3,
      origin: "Olga",
      items: builtItems,
    });

    const errors = response.getErrors([]);
    if (errors.length > 0) {
      throw new Error("Não foi possível incluir os itens na mesa");
    }

  }

  async callWaiter() {
    const status = await this.getStatus();
    if (status === TableStatus.PRECLOSED || status === TableStatus.CLOSED) {
      throw new ClosingTableException();
    }

    const response = await this.client.addItemToOrder({
      table: this.colibriConfiguration.externalId,
      mode: 3,
      origin: "Olga",
      items: [
        {
          codigo: this.colibriConfiguration.callWaiterSku,
          descricao: "Chamar Garçom",
          itens: null,
          marchar: null,
          observacao: null,
          preco: 0,
          quantidade: 1,
          tipo: "normal",
        },
      ],
    });

    const errors = response.getErrors([]);
    if (errors.length > 0) {
      throw new Error("Não foi possível incluir os itens na mesa");
    }
  }

  async preClose() {
    throw new Error("Pré-fechamento indisponível");
  }

  async getStatus () {
    const overview = await this.getOverview();
    return overview.status;
  }

  async getOverview() {
    const operationResponse = await this.client.getOperationFromTable({
      table: this.colibriConfiguration.externalId,
      mode: 3,
      origin: "Olga",
    });

    const operation = operationResponse.getData({ dados: {} }).dados;

    const total = operation?.totais?.total || 0;
    const subtotal = operation?.totais?.subtotal || 0;
    const fee = operation?.totais?.servico || 0;

    const operationStatus = String(
      operation?.status || "UNKNOWN"
    ).toLocaleLowerCase();
    const statusMap = {
      livre: TableStatus.AVAILABLE,
      consumindo: TableStatus.OPENED,
      "em pagamento": TableStatus.PRECLOSED,
    };
    const status = statusMap[operationStatus] || TableStatus.AVAILABLE;

    const operationItems = operation.consumos?.[0]?.venda?.itens || [];
    const filteredItems = operationItems.filter((item) => {
      const isCancelled = !!item.cancelado;
      const isTranferred = !!item.transferido;

      const isWaiterProduct = String(item.codigo) === String(this.colibriConfiguration.callWaiterSku);
      return !isCancelled && !isTranferred && !isWaiterProduct;
    });
    const items = filteredItems.map(
      (item) =>
        new TableItem({
          id: item.item_id,
          name: item.descricao,
          quantity: item.quantidade,
          unitPrice: item.preco,
          totalPrice: item.valor,
          items: [],
          sort: item.indice,
        })
    );

    return new TableOverview({
      subtotal,
      total,
      fee,
      status,
      items,
      payersQuantity: operation.numeroDePessoas,
    });
  }
}
